export const layoutMaxWidth = '64.27rem';



// WEBPACK FOOTER //
// ./src/layouts/const.js